import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { reportPilotIssue } from "../../lib/pilotDiagnostics";

export default function PilotSupport() {
  const { pathname } = useLocation();
  const [state, setState] = useState("");
  const [reference, setReference] = useState("");
  if (!/^\/limelite(?:\/|$)/.test(pathname)) return null;
  async function report() {
    setState("sending");
    try { setReference(await reportPilotIssue("support_request")); setState("sent"); }
    catch (_) { setState("failed"); }
  }
  return <aside className="border-t border-lime-900/50 bg-off-black px-4 py-5 text-sm text-silver-medium" aria-label="Pilot support">
    <div className="mx-auto max-w-6xl flex flex-wrap items-center justify-between gap-3">
      <div><p className="font-medium text-silver-light">Stuck during your pilot?</p><p>Send the team a technical report. Passwords, payment details and form contents are excluded.</p></div>
      <button type="button" onClick={report} disabled={state === "sending" || state === "sent"} className="rounded-lg border border-lime-700 px-4 py-2 text-lime-400 disabled:opacity-60">{state === "sending" ? "Sending…" : state === "sent" ? "Report sent" : "Report a problem"}</button>
      <div role="status" className="w-full">
        {state === "sent" && <p>We received your report. Keep this support reference: <code className="break-all">{reference}</code>. <Link to="/contact" className="underline">Contact us</Link> to add details.</p>}
        {state === "failed" && <p>We couldn’t save your report. Please <Link to="/contact" className="underline">contact us directly</Link>.</p>}
      </div>
    </div>
  </aside>;
}
